// extracted by mini-css-extract-plugin
export default {"button":"Button_button__poVKX","outline":"Button_outline__Qrq6o","bulky":"Button_bulky__TURkw"};